import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { FaBars } from "react-icons/fa/";
import { ThemeToggler } from "gatsby-plugin-dark-mode";
import { Popover } from "@headlessui/react";

import MenuBar from "./MenuBar";
import Navbar from "./Navbar";
import ThemeToggle from "./ThemeToggle";
import Footer from "./Footer";
import UpdateBanner from "./UpdateBanner";

const Header = ({ children, headerClassName = "" }) => {
  return (
    <header
      className={`sticky top-0 z-20 h-28 w-full bg-violet ${headerClassName}`}
    >
      {children}
    </header>
  );
};

const Layout = ({ children }) => {
  return (
    <ThemeToggler>
      {({ theme, toggleTheme }) => (
        <Popover className="flex flex-col items-center w-full min-h-screen bg-paper dark:bg-navy">
          {({ open, close }) => (
            <>
              <Header headerClassName="relative lg:shrink-0">
                <div className="lg:hidden">
                  <button className="absolute top-16 z-40 right-6">
                    <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
                  </button>
                  {/* Straight on the violet header, no separate white/dark
                      badge box — the simpler mockup treatment, since the
                      header is always violet on mobile regardless of theme
                      (so the mark only ever needs the white variant, unlike
                      the desktop badge which swaps mark+background together). */}
                  <div className="absolute left-6 top-1/2 flex -translate-y-1/2 items-center">
                    <Link to="/">
                      <StaticImage
                        src="../images/logo-white.png"
                        alt="ensuperlig"
                        placeholder="blurred"
                        layout="fixed"
                        width={110}
                        height={79}
                        imgStyle={{ objectFit: "contain" }}
                      />
                    </Link>
                  </div>
                  <Popover.Button>
                    <FaBars className="absolute right-6 top-4 w-7 h-7 text-white cursor-pointer" />
                  </Popover.Button>
                </div>
                <Navbar theme={theme} toggleTheme={toggleTheme} />
              </Header>
              {open ? (
                <Popover.Panel className="absolute z-5 w-full top-2 lg:hidden">
                  <MenuBar closeMenu={close} />
                </Popover.Panel>
              ) : (
                <>
                  <main className="lg:mt-8 lg:max-w-screen-2xl w-full flex flex-col lg:flex-row grow bg-paper dark:bg-navy">
                    {children}
                  </main>
                  <Footer className="lg:flex" />
                </>
              )}
              <UpdateBanner />
            </>
          )}
        </Popover>
      )}
    </ThemeToggler>
  );
};

export default Layout;
